import React from 'react';
import { PlacementType } from 'react-laag/dist/PlacementType';

import { UITooltip } from './UITooltip';
import { useTooltip, UseTooltipProps } from './useTooltip';

type SimpleTooltipProps = Omit<UseTooltipProps, 'auto'> & {
  content?: React.ReactNode;
  noPointerEvents?: boolean;
  children?: React.ReactNode;
  placement?: PlacementType;
  strictPlacement?: boolean;
  dataRole?: string;
  triggerDataRole?: string;
  triggerClassName?: string;
};

export const SimpleTooltip: React.FC<SimpleTooltipProps> = ({
  content,
  noPointerEvents,
  children,
  placement = 'top-center',
  strictPlacement = false,
  dataRole,
  triggerDataRole,
  triggerClassName,
  disabled,
  ...passProps
}) => {
  const tooltipProps = useTooltip({
    placement,
    auto: !strictPlacement,
    disabled: !content || disabled,
    ...passProps,
  });

  if (!content) {
    return <>{children}</>;
  }

  return (
    <span className={triggerClassName} data-role={triggerDataRole} {...tooltipProps.triggerProps}>
      {children}
      {tooltipProps.isOpen &&
        tooltipProps.renderLayer(
          <UITooltip
            {...tooltipProps.layerProps}
            noPointerEvents={noPointerEvents}
            dataRole={dataRole}
          >
            {content}
          </UITooltip>,
        )}
    </span>
  );
};
